import welcomeDeDE from '../../../../assets/images/userManual/welcome_de-DE.svg';
import vehicleOverview1DeDE from '../../../../assets/images/userManual/vehicle-overview-1_de-DE.png';
import vehicleOverview2DeDE from '../../../../assets/images/userManual/vehicle-overview-2_de-DE.png';
import addingServiceCard1DeDE from '../../../../assets/images/userManual/add-service-card-1_de-DE.svg';
import addingServiceCard2DeDE from '../../../../assets/images/userManual/add-service-card-2_de-DE.svg';
import addingServiceCard3DeDE from '../../../../assets/images/userManual/add-service-card-3_de-DE.svg';
import addingServiceCard4DeDE from '../../../../assets/images/userManual/add-service-card-4_de-DE.png';
import addingServiceCard5DeDE from '../../../../assets/images/userManual/add-service-card-5_de-DE.png';
import addingServiceCard6DeDE from '../../../../assets/images/userManual/add-service-card-6_de-DE.png';
import activatingServices1DeDE from '../../../../assets/images/userManual/activating-services-1_de-DE.svg';
import activatingServices2DeDE from '../../../../assets/images/userManual/activating-services-2_de-DE.svg';
import dashboardOverview1DeDE from '../../../../assets/images/userManual/dashboard-overview-1_de-DE.webp';
import dashboardOverviewCard1DeDE from '../../../../assets/images/userManual/dashboard-overview-card-1_de-DE.png';
import dashboardOverviewCard2DeDE from '../../../../assets/images/userManual/dashboard-overview-card-2_de-DE.png';
import dashboardOverviewCard3DeDE from '../../../../assets/images/userManual/dashboard-overview-card-3_de-DE.png';
import dashboardOverviewCard4DeDE from '../../../../assets/images/userManual/dashboard-overview-card-4_de-DE.webp';
import dashboardOverviewCard5DeDE from '../../../../assets/images/userManual/dashboard-overview-card-5_de-DE.webp';
import dashboardOverviewCard6DeDE from '../../../../assets/images/userManual/dashboard-overview-card-6_de-DE.png';
import dashboardOverviewCard7DeDE from '../../../../assets/images/userManual/dashboard-overview-card-7_de-DE.png';
import displayTransactions1DeDE from '../../../../assets/images/userManual/display-transactions-1_de-DE.webp';
import displayTransactions2DeDE from '../../../../assets/images/userManual/display-transactions-2_de-DE.webp';
import displayTransactions3DeDE from '../../../../assets/images/userManual/display-transactions-3_de-DE.webp';
import bookingOverview1DeDE from '../../../../assets/images/userManual/booking-overview-1_de-DE.png';
import bookingOverview2DeDE from '../../../../assets/images/userManual/booking-overview-2_de-DE.png';
import mobileFueling1DeDE from '../../../../assets/images/userManual/mobile-fueling-1_de-DE.png';
import mobileFueling2DeDE from '../../../../assets/images/userManual/mobile-fueling-2_de-DE.png';
import mobileFueling3DeDE from '../../../../assets/images/userManual/mobile-fueling-3_de-DE.png';
import mobileFueling4DeDE from '../../../../assets/images/userManual/mobile-fueling-4_de-DE.png';
import parking1DeDE from '../../../../assets/images/userManual/parking-1_de-DE.png';
import parking2DeDE from '../../../../assets/images/userManual/parking-2_de-DE.png';
import parking3DeDE from '../../../../assets/images/userManual/parking-3_de-DE.png';
import parking4DeDE from '../../../../assets/images/userManual/parking-4_de-DE.png';
import parkingApp1DeDE from '../../../../assets/images/userManual/parking-app-1_de-DE.png';
import parkingApp2DeDE from '../../../../assets/images/userManual/parking-app-2_de-DE.png';
import parkingApp3DeDE from '../../../../assets/images/userManual/parking-app-3_de-DE.png';
import parkingApp4DeDE from '../../../../assets/images/userManual/parking-app-4_de-DE.png';

import welcomeEnGB from '../../../../assets/images/userManual/welcome_en-GB.svg';
import vehicleOverview1EnGB from '../../../../assets/images/userManual/vehicle-overview-1_en-GB.png';
import vehicleOverview2EnGB from '../../../../assets/images/userManual/vehicle-overview-2_en-GB.png';
import addingServiceCard1EnGB from '../../../../assets/images/userManual/add-service-card-1_en-GB.svg';
import addingServiceCard2EnGB from '../../../../assets/images/userManual/add-service-card-2_en-GB.svg';
import addingServiceCard3EnGB from '../../../../assets/images/userManual/add-service-card-3_en-GB.svg';
import addingServiceCard4EnGB from '../../../../assets/images/userManual/add-service-card-4_en-GB.png';
import addingServiceCard5EnGB from '../../../../assets/images/userManual/add-service-card-5_en-GB.png';
import addingServiceCard6EnGB from '../../../../assets/images/userManual/add-service-card-6_en-GB.png';
import activatingServices1EnGB from '../../../../assets/images/userManual/activating-services-1_en-GB.svg';
import activatingServices2EnGB from '../../../../assets/images/userManual/activating-services-2_en-GB.svg';
import dashboardOverview1EnGB from '../../../../assets/images/userManual/dashboard-overview-1_en-GB.webp';
import dashboardOverviewCard1EnGB from '../../../../assets/images/userManual/dashboard-overview-card-1_en-GB.png';
import dashboardOverviewCard2EnGB from '../../../../assets/images/userManual/dashboard-overview-card-2_en-GB.png';
import dashboardOverviewCard3EnGB from '../../../../assets/images/userManual/dashboard-overview-card-3_en-GB.png';
import dashboardOverviewCard4EnGB from '../../../../assets/images/userManual/dashboard-overview-card-4_en-GB.webp';
import dashboardOverviewCard5EnGB from '../../../../assets/images/userManual/dashboard-overview-card-5_en-GB.webp';
import dashboardOverviewCard6EnGB from '../../../../assets/images/userManual/dashboard-overview-card-6_en-GB.png';
import dashboardOverviewCard7EnGB from '../../../../assets/images/userManual/dashboard-overview-card-7_en-GB.png';
import displayTransactions1EnGB from '../../../../assets/images/userManual/display-transactions-1_en-GB.webp';
import displayTransactions2EnGB from '../../../../assets/images/userManual/display-transactions-2_en-GB.webp';
import displayTransactions3EnGB from '../../../../assets/images/userManual/display-transactions-3_en-GB.webp';
import bookingOverview1EnGB from '../../../../assets/images/userManual/booking-overview-1_en-GB.png';
import bookingOverview2EnGB from '../../../../assets/images/userManual/booking-overview-2_en-GB.png';
import mobileFueling1EnGB from '../../../../assets/images/userManual/mobile-fueling-1_en-GB.png';
import mobileFueling2EnGB from '../../../../assets/images/userManual/mobile-fueling-2_en-GB.png';
import mobileFueling3EnGB from '../../../../assets/images/userManual/mobile-fueling-3_en-GB.png';
import mobileFueling4EnGB from '../../../../assets/images/userManual/mobile-fueling-4_en-GB.png';
import parking1EnGB from '../../../../assets/images/userManual/parking-1_en-GB.png';
import parking2EnGB from '../../../../assets/images/userManual/parking-2_en-GB.png';
import parking3EnGB from '../../../../assets/images/userManual/parking-3_en-GB.png';
import parking4EnGB from '../../../../assets/images/userManual/parking-4_en-GB.png';
import parkingApp1EnGB from '../../../../assets/images/userManual/parking-app-1_en-GB.png';
import parkingApp2EnGB from '../../../../assets/images/userManual/parking-app-2_en-GB.png';
import parkingApp3EnGB from '../../../../assets/images/userManual/parking-app-3_en-GB.png';
import parkingApp4EnGB from '../../../../assets/images/userManual/parking-app-4_en-GB.png';

import manAppIcon from '../../../../assets/images/userManual/man-app-icon.png';
import manAppleStoreQr from '../../../../assets/images/userManual/man-apple-store-qr.png';
import manPlayStoreQr from '../../../../assets/images/userManual/man-play-store-qr.png';
import playStore from '../../../../assets/images/userManual/play-store.svg';
import appStore from '../../../../assets/images/userManual/app-store.svg';

export const imageKeys = {
  welcome: 'welcome',
  vehicleOverview1: 'vehicleOverview1',
  vehicleOverview2: 'vehicleOverview2',
  addingServiceCard1: 'addingServiceCard1',
  addingServiceCard2: 'addingServiceCard2',
  addingServiceCard3: 'addingServiceCard3',
  addingServiceCard4: 'addingServiceCard4',
  addingServiceCard5: 'addingServiceCard5',
  addingServiceCard6: 'addingServiceCard6',
  activatingServices1: 'activatingServices1',
  activatingServices2: 'activatingServices2',
  dashboardOverview1: 'dashboardOverview1',
  dashboardOverviewCard1: 'dashboardOverviewCard1',
  dashboardOverviewCard2: 'dashboardOverviewCard2',
  dashboardOverviewCard3: 'dashboardOverviewCard3',
  dashboardOverviewCard4: 'dashboardOverviewCard4',
  dashboardOverviewCard5: 'dashboardOverviewCard5',
  dashboardOverviewCard6: 'dashboardOverviewCard6',
  dashboardOverviewCard7: 'dashboardOverviewCard7',
  displayTransactions1: 'displayTransactions1',
  displayTransactions2: 'displayTransactions2',
  displayTransactions3: 'displayTransactions3',
  bookingOverview1: 'bookingOverview1',
  bookingOverview2: 'bookingOverview2',
  mobileFueling1: 'mobileFueling1',
  mobileFueling2: 'mobileFueling2',
  mobileFueling3: 'mobileFueling3',
  mobileFueling4: 'mobileFueling4',
  parking1: 'parking1',
  parking2: 'parking2',
  parking3: 'parking3',
  parking4: 'parking4',
  parkingApp1: 'parkingApp1',
  parkingApp2: 'parkingApp2',
  parkingApp3: 'parkingApp3',
  parkingApp4: 'parkingApp4',
  manAppIcon: 'manAppIcon',
  manAppleStoreQr: 'manAppleStoreQr',
  manPlayStoreQr: 'manPlayStoreQr',
  playStore: 'playStore',
  appStore: 'appStore',
} as const;

export const getImageAssetWithLocale = (
  imageKey: keyof typeof imageKeys,
  locale: string,
): string => {
  const imagesGerman = {
    welcome: welcomeDeDE,
    vehicleOverview1: vehicleOverview1DeDE,
    vehicleOverview2: vehicleOverview2DeDE,
    addingServiceCard1: addingServiceCard1DeDE,
    addingServiceCard2: addingServiceCard2DeDE,
    addingServiceCard3: addingServiceCard3DeDE,
    addingServiceCard4: addingServiceCard4DeDE,
    addingServiceCard5: addingServiceCard5DeDE,
    addingServiceCard6: addingServiceCard6DeDE,
    activatingServices1: activatingServices1DeDE,
    activatingServices2: activatingServices2DeDE,
    dashboardOverview1: dashboardOverview1DeDE,
    dashboardOverviewCard1: dashboardOverviewCard1DeDE,
    dashboardOverviewCard2: dashboardOverviewCard2DeDE,
    dashboardOverviewCard3: dashboardOverviewCard3DeDE,
    dashboardOverviewCard4: dashboardOverviewCard4DeDE,
    dashboardOverviewCard5: dashboardOverviewCard5DeDE,
    dashboardOverviewCard6: dashboardOverviewCard6DeDE,
    dashboardOverviewCard7: dashboardOverviewCard7DeDE,
    displayTransactions1: displayTransactions1DeDE,
    displayTransactions2: displayTransactions2DeDE,
    displayTransactions3: displayTransactions3DeDE,
    bookingOverview1: bookingOverview1DeDE,
    bookingOverview2: bookingOverview2DeDE,
    mobileFueling1: mobileFueling1DeDE,
    mobileFueling2: mobileFueling2DeDE,
    mobileFueling3: mobileFueling3DeDE,
    mobileFueling4: mobileFueling4DeDE,
    parking1: parking1DeDE,
    parking2: parking2DeDE,
    parking3: parking3DeDE,
    parking4: parking4DeDE,
    parkingApp1: parkingApp1DeDE,
    parkingApp2: parkingApp2DeDE,
    parkingApp3: parkingApp3DeDE,
    parkingApp4: parkingApp4DeDE,
    manAppIcon,
    manAppleStoreQr,
    manPlayStoreQr,
    playStore,
    appStore,
  };
  const imagesEnglish = {
    welcome: welcomeEnGB,
    vehicleOverview1: vehicleOverview1EnGB,
    vehicleOverview2: vehicleOverview2EnGB,
    addingServiceCard1: addingServiceCard1EnGB,
    addingServiceCard2: addingServiceCard2EnGB,
    addingServiceCard3: addingServiceCard3EnGB,
    addingServiceCard4: addingServiceCard4EnGB,
    addingServiceCard5: addingServiceCard5EnGB,
    addingServiceCard6: addingServiceCard6EnGB,
    activatingServices1: activatingServices1EnGB,
    activatingServices2: activatingServices2EnGB,
    dashboardOverview1: dashboardOverview1EnGB,
    dashboardOverviewCard1: dashboardOverviewCard1EnGB,
    dashboardOverviewCard2: dashboardOverviewCard2EnGB,
    dashboardOverviewCard3: dashboardOverviewCard3EnGB,
    dashboardOverviewCard4: dashboardOverviewCard4EnGB,
    dashboardOverviewCard5: dashboardOverviewCard5EnGB,
    dashboardOverviewCard6: dashboardOverviewCard6EnGB,
    dashboardOverviewCard7: dashboardOverviewCard7EnGB,
    displayTransactions1: displayTransactions1EnGB,
    displayTransactions2: displayTransactions2EnGB,
    displayTransactions3: displayTransactions3EnGB,
    bookingOverview1: bookingOverview1EnGB,
    bookingOverview2: bookingOverview2EnGB,
    mobileFueling1: mobileFueling1EnGB,
    mobileFueling2: mobileFueling2EnGB,
    mobileFueling3: mobileFueling3EnGB,
    mobileFueling4: mobileFueling4EnGB,
    parking1: parking1EnGB,
    parking2: parking2EnGB,
    parking3: parking3EnGB,
    parking4: parking4EnGB,
    parkingApp1: parkingApp1EnGB,
    parkingApp2: parkingApp2EnGB,
    parkingApp3: parkingApp3EnGB,
    parkingApp4: parkingApp4EnGB,
    manAppIcon,
    manAppleStoreQr,
    manPlayStoreQr,
    playStore,
    appStore,
  };

  if (locale === 'de-DE') {
    return imagesGerman[imageKey];
  } else {
    return imagesEnglish[imageKey];
  }
};
